import * as React from "react";
import {IReduxState} from "../../reducers";
import {connect} from "react-redux";
import {IProfile, IUserStatus, IUTMParams, PurposeType} from "StateInterface";
import {RouteComponentProps} from "react-router-dom";
import BankAccountDetails from "consent/bankAccountDetails";
import {getPostApprovalFormFields, logError, saveOpportunityProfile, updatePaField} from "consent/api";
import Loading from "components/loading";
import {getLatestLoanOpp} from "consent/actions";
import {InsuranceBundle} from "consent/insuranceBundle";
import DocUploadComposer from "loan-application/application/doc-upload";
import {DOC_TYPE} from "loan-application/application/doc-upload/utils";
import {DocTypes, getContentType} from "userform/utils";
import {DocUploadModes} from "loan-application/utils";
import {uploadDocument} from "documents/api";
import ConsentBox from "consent/utils/consentBox";
import {Button} from "web-com";
import AlternateMobileNumber from "consent/alternateMobileNumber";
import {partnerOfferings} from "login/config";
import {ceil} from "lodash";
import {isWebview} from "utils";
import ".././styles.scss";
import {LoginMode} from "login/reducer";

interface IConnectProps {
    loading: boolean;
    lenderOpportunityId: string;
    userStatus: IUserStatus;
    userId: number;
    dispatch?: (action: any) => void;
    pathname: string;
    profile: IProfile;
    sourcingCode: string;
    utmParams: IUTMParams;
    isAndroid: boolean;
    isPartnerAndroid: boolean;
    loginMode: LoginMode;
    utm_source: string;
    email?: string;
}

interface IState {
    paFormFields: string[];
    loading: boolean;
    bankAccountDetails: boolean;
    bankAccountDetailsNach: boolean;
    insuranceNomineeDetails: boolean;
    selfie: boolean;
    docUploadError: string;
    docUploadSuccess: string;
    alternateMobileNumber: boolean;
}

enum paFields {
    BANK_DETAILS = "BANK_DETAILS",
    BANK_DETAILS_NACH = "BANK_DETAILS_NACH",
    INSURANCE_NOMINEE = "INSURANCE_NOMINEE",
    SELFIE = "SELFIE",
    ALTERNATE_NUMBER = "ALTERNATE_NUMBER",
}

class PAForm extends React.Component<IConnectProps & RouteComponentProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            paFormFields: null,
            loading: false,
            bankAccountDetails: false,
            bankAccountDetailsNach: false,
            insuranceNomineeDetails: false,
            selfie: false,
            docUploadError: null,
            docUploadSuccess: null,
            alternateMobileNumber: null,
        };
        this.docHandleChange = this.docHandleChange.bind(this);
        this.getPaFormFields = this.getPaFormFields.bind(this);
    }

    public getPaFormFields = () => {
        getPostApprovalFormFields(this.props.lenderOpportunityId).then((res) => {
            if (res.status === 200) {
                const paApprovalFields = res.data.postApprovalFields;
                this.setState({
                    paFormFields: paApprovalFields,
                    bankAccountDetails: paApprovalFields.includes(paFields.BANK_DETAILS),
                    bankAccountDetailsNach: paApprovalFields.includes(paFields.BANK_DETAILS_NACH),
                    insuranceNomineeDetails: paApprovalFields.includes(paFields.INSURANCE_NOMINEE),
                    selfie: paApprovalFields.includes(paFields.SELFIE),
                    alternateMobileNumber: paApprovalFields.includes(paFields.ALTERNATE_NUMBER),
                });
            }
            this.setState({
                loading: false,
            });
        });
    }

    public componentDidMount() {
        this.setState({
            loading: true,
        });
        this.props.lenderOpportunityId && this.getPaFormFields();
    }

    public componentWillReceiveProps(): void {
        if (!this.state.paFormFields && this.props.lenderOpportunityId) {
            this.getPaFormFields();
        }
    }

    public checkPaComplete() {
        const paComplete = !this.state.bankAccountDetails && !this.state.bankAccountDetailsNach && !this.state.insuranceNomineeDetails
            && !this.state.selfie && !this.state.alternateMobileNumber;
        if (paComplete && this.props.lenderOpportunityId) {
            updatePaField(
                this.props.lenderOpportunityId, paComplete).then((res) => {
                if (res.status === 200) {
                    this.props.dispatch(getLatestLoanOpp(this.props.lenderOpportunityId));
                } else {
                    this.setState({
                        loading: false,
                    });
                }
            });
        } else {
            this.setState({
                loading: false,
            });
        }

    }

    public updateOppProfile(profile: IProfile, curField: string) {
        this.setState({
            loading: true,
        });
        if (profile && this.props.lenderOpportunityId) {
            saveOpportunityProfile(this.props.lenderOpportunityId, profile)
                .then((res) => {
                    if (curField === paFields.BANK_DETAILS) {
                        this.setState({
                            bankAccountDetails: false,
                        });
                    } else if (curField === paFields.BANK_DETAILS_NACH) {
                        this.setState({
                            bankAccountDetailsNach: false,
                        });
                    } else if (curField === paFields.INSURANCE_NOMINEE) {
                        this.setState({
                            insuranceNomineeDetails: false,
                        });
                    }
                })
        }
        if (this.state.docUploadSuccess && curField === paFields.SELFIE) {
            this.setState({selfie: false});
        }
    }

    public async docHandleChange(name: DocTypes, value: string) {
        if (name && value) {
            this.setState({loading: true, docUploadError: null});
            const uploadDocbody = {
                contentType: getContentType(value).mime,
                userId: this.props.userId,
                docMode: DocUploadModes.SCAN_UPLOAD,
                docType: name,
                imageB64: value,
            };
            const bytes = ((uploadDocbody?.imageB64.length * 6) / 8);
            const kb = ceil(bytes / 1000);
            try {
                const res = await uploadDocument(name, uploadDocbody);
                if (res) {
                    this.setState({docUploadSuccess: paFields.SELFIE, loading: false});
                }
            } catch (error) {
                if (error.config && error.config.data) {
                    const parseData = JSON.parse(error.config.data);
                    delete parseData.imageB64;
                    delete error.config.headers.Authorization;
                    delete error.response.config.headers.Authorization;
                    error.config.data = JSON.stringify(parseData);
                }
                const navigatorConnection = navigator as any;
                const internetSpeed = +navigatorConnection.connection.downlink * 1024;
                const networkType = navigatorConnection.connection.effectiveType;
                logError({type: "error", options: {name: "selfie-error-logs",internetSpeed:`${internetSpeed} kb`, networkType: networkType, userId: this.props.userId, imageSize: `${kb} kb`, email: this.props.email, isWebView: isWebview(), error}});
                this.setState({docUploadError: error?.response?.data?.err || "Something went wrong", loading: false});
            }
        }
    }

    public componentDidUpdate(prevProps, prevState) {
        const {bankAccountDetails, bankAccountDetailsNach, insuranceNomineeDetails, selfie, alternateMobileNumber} = this.state;
        if (bankAccountDetails !== prevState.bankAccountDetails
            || bankAccountDetailsNach !== prevState.bankAccountDetailsNach
            || alternateMobileNumber !== prevState.alternateMobileNumber
            || insuranceNomineeDetails !== prevState.insuranceNomineeDetails
            || selfie !== prevState.selfie
        ) {
            this.checkPaComplete();
        }
    }

    public renderPaForm() {
        if (this.state.loading) {
            return <Loading active={this.state.loading}/>;
        } else if (!this.state.paFormFields) {
            return <div> There was problem, Please contact {partnerOfferings[this.props.utm_source]?.supportEmail || "support@myshubhlife.com"}</div>;
        } else if (this.state.alternateMobileNumber) {
            return <AlternateMobileNumber
                utm_source={this.props.utm_source}
                oppId={this.props.lenderOpportunityId}
                onComplete={() => this.setState({alternateMobileNumber: false})}
            />;
        } else if (this.state.bankAccountDetails) {
            return <BankAccountDetails
                utm_source={this.props.utm_source}
                profile={this.props.profile}
                onComplete={(profile) => {
                    this.updateOppProfile(profile, paFields.BANK_DETAILS);
                }}
             purposeType={PurposeType.DISBURSAL}/>;
        }
        else if (this.state.bankAccountDetailsNach) {
            return <BankAccountDetails
                utm_source={this.props.utm_source}
                profile={this.props.profile}
                onComplete={(profile) => {
                    this.updateOppProfile(profile, paFields.BANK_DETAILS_NACH);
                }}
                purposeType={PurposeType.NACH}
            />;
        }
        else if (this.state.insuranceNomineeDetails) {
            return <InsuranceBundle
                profile={this.props.profile}
                onComplete={(profile) => {
                    this.updateOppProfile(profile, paFields.INSURANCE_NOMINEE);
                }}
                isAndroid={this.props.isAndroid && !this.props.isPartnerAndroid}
            />;
        } else if (this.state.selfie) {
            return (
                <ConsentBox>
                    <DocUploadComposer
                        label="Selfie"
                        identifier={[DOC_TYPE.SELFIE]}
                        errorMsg={this.state.docUploadError && {SELFIE : this.state.docUploadError}}
                        uploaded={[this.state.docUploadSuccess]}
                        handleChange={this.docHandleChange}
                        isAndroid={this.props.isAndroid}
                    />
                    <div className="button-container">
                        <Button
                            bgColor={partnerOfferings[this.props.utm_source]?.colors?.green}
                            buttonText={"Proceed"}
                            onClick={() => this.updateOppProfile(null, paFields.SELFIE)}
                            rounded={true}
                            isDisabled={!this.state.docUploadSuccess}
                        />
                    </div>
                </ConsentBox>
            );
        }
    }

    public render() {
        return (
            <div style={{minHeight: "100vh"}}>
                {this.renderPaForm()}
            </div>
        );
    }

}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    const userStatus = state.userform.userStatus;
    return {
        userStatus,
        lenderOpportunityId: state.consent.lenderOpportunityId,
        loading: state.consent.loading,
        userId: state.login.auth.userId,
        pathname: state.userform.param,
        profile: state.userform.userStatus ? state.userform.userStatus.profileStatus : null,
        sourcingCode: state.userform.sourcingCode,
        utmParams: state.userform.utmParams,
        isAndroid: state.login.isAndroid,
        isPartnerAndroid: state.login.isPartnerAndroid,
        loginMode: state.login.loginMode,
        utm_source: state.login.authExt ? state.login.authExt.utm_source : null,
        email: state.login?.auth?.email,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(PAForm);
